export class dcAttributeFilterTVP implements dcAttributeFilter {
  AttributeTemplateVersionID: number;
  ElementTypeID: number;
  ElementVersionID: number;
  RootElementVersionID: number;
  ElementPath: string;
  AttributeTemplatePath: string;
  QueryOrder: number;
  QueryOperation: number;
}

export interface dcAttributeFilter {
  ElementPath?: string;
  AttributeTemplatePath?: string;
  QueryOrder: number;
  QueryOperation: number;
}
